import axios from 'axios';
import { getStoredAdminToken, persistAdminToken, broadcastUnauthorized } from '../constants/adminNavigation';

const api = axios.create({
  baseURL:  'https://ifstatic.com/api'
  // baseURL:  'http://localhost:5003/api'
});

api.interceptors.request.use((config) => {
  const token = getStoredAdminToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      persistAdminToken(null);
      broadcastUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default api;
